export default "__VITE_ASSET__PHRXtAj8__"